import { CardTab } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/CardTab/CardTab';
import { TabItem } from 'components/DesignSystem/Tabs';

export type RiskRegisterFormTabs = 'details' | 'linkedActivities' | 'auditLog';

export const tabsArrData: TabItem[] = [
    {
        value: 'details',
        label: 'Card Details',
    },
    {
        value: 'linkedActivities',
        label: 'Linked Activities',
    },
    {
        value: 'auditLog',
        label: 'Audit Log',
    },
];
